<template>
    <div class="collapse">
        <div class="collapse-header" @click="toggleCollapse">
            <span v-html="title"></span>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="{ opened: isOpened }"
            >
                <path d="M6 9l6 6 6-6" />
            </svg>
        </div>
        <div class="collapse-content" v-if="isOpened">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.collapse {
    &-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        padding: 16px 12px 16px 0;
        cursor: pointer;

        .opened {
            transform: rotate(180deg);
        }
    }
}
</style>

<script>
import SvgIcon from "./SvgIcon.vue";

export default {
    components: {
        SvgIcon
    },

    props: {
        title: {
            type: String,
            required: true
        },
        defaultOpened: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isOpened: this.defaultOpened
        };
    },

    methods: {
        toggleCollapse() {
            this.isOpened = !this.isOpened;
        }
    }
};
</script>
